const stringToJSON = (str) => {
    // Remove all quotes to normalize the input
    const removeQuotes = str.replace(/['"]+/g, '')
    // Add double quotes back to the keys and values
    const wrappedKeysAndValues = removeQuotes.replace(/([{,])(\w+)(:)([^{},]+)/g, '$1"$2"$3"$4"');
    return wrappedKeysAndValues
}

export default stringToJSON